import React from 'react';
import { Typography } from '@saucelabs/ds-typography';

import { USAGE_AVAILABLE_PRODUCTS } from '../constants';
import { PLANS_ICON_MAP } from '../containers/UsagePurchaseContainer';

export const CreditsRatesTable: React.FC = () => (
  <table
    className="table-auto w-full"
    style={{ borderSpacing: 0 }}
  >
    <thead>
      <tr>
        <th className="px-1 py-2 border-0 border-b border-solid border-gray-400">
          <Typography
            variant="overline"
          >
            Virtual Devices
          </Typography>
        </th>
        <th className="px-1 py-2 border-0 border-b border-solid border-gray-400">
          <Typography
            variant="overline"
          >
            Credits Rate
          </Typography>
        </th>
      </tr>
    </thead>
    <tbody>
      {USAGE_AVAILABLE_PRODUCTS.VIRTUAL.map((product) => (
        <tr key={`table-row-usage-${product.name}`}>
          <td className="p-1 border-0 border-b border-solid border-gray-200 text-high-emphasis">
            {PLANS_ICON_MAP[product.name]}
            {' '}
            {product.name}
          </td>
          <td className="p-1 border-0 border-b border-solid border-gray-200 text-high-emphasis">
            {product.rate}
            {' '}
            credits/min
          </td>
        </tr>
      ))}
    </tbody>
    <thead>
      <tr>
        <th className="px-1 py-2 border-0 border-b border-solid border-gray-400">
          <Typography
            className="mt-2"
            variant="overline"
          >
            Public real Devices
          </Typography>
        </th>
        <th className="px-1 py-2 border-0 border-b border-solid border-gray-400">
          <Typography
            className="mt-2"
            variant="overline"
          >
            Credits Rate
          </Typography>
        </th>
      </tr>
    </thead>
    <tbody>
      {USAGE_AVAILABLE_PRODUCTS.REAL.map((product) => (
        <tr key={`table-row-usage-${product.name}`}>
          <td className="p-1 border-0 border-b border-solid border-gray-200 text-high-emphasis">
            {PLANS_ICON_MAP[product.name]}
            {' '}
            {product.name}
          </td>
          <td className="p-1 border-0 border-b border-solid border-gray-200 text-high-emphasis">
            {product.rate}
            {' '}
            credits/min
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
